import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import classes from "../CSS/routes.module.css";
import tfif from "../assets/tfif.jpg";
import susan from "../assets/susan.jpg";
import grace from "../assets/grace.jpg";
import ada1 from "../assets/ada1.jpeg";
import about from "../assets/about.png";
import texture from "../assets/texture.jpg"
import CustomNavbar from "../components/navbar";
import { Row, Col } from "react-bootstrap";
import Carousal from "../components/carousal";
import Footer from "../components/footer";
import banner2 from "../assets/banner2.png";

const About = ()=>{
    Aos.init({duration:2000})
    return(
        <>
            <div style={{ backgroundImage:`url(${tfif})`,
                color:"white",
                fontFamily:"Lexend Giga"}} className={classes.parallax}>
                        <CustomNavbar />
                    <div className={classes.parallax} style={{
                             display:"flex",
                             alignItems:"center",
                             justifyContent:"center",
                             flexDirection:"column",
                        }} >

                            <center><h1 data-aos="fade-down" className={classes.Header} >Have a voice. Have a choice.</h1></center>
                    </div>
            </div>
            <div  style={{backgroundImage:`url(${texture})`,
                backgroundSize:"100% 100%",
                
                }}>
            <div className={classes.Seva} style={{backgroundImage:`url(${banner2})`,backgroundSize:"100% 100%"}}></div><br/><br/>
            <div style={{paddingTop:"50px"}} className="container">
                <Row>
                    <Col style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",}} md={6} sm={12}>
                    <center><h2 data-aos="fade-up" style={{fontWeight:"bold",borderBottom:"2px solid #efb1ff",paddingBottom:"20px"}}>Susan B. Anthony</h2></center><br/>
                    <center><p data-aos="fade-up" style={{fontSize:"18px",fontWeight:"500"}}>American social reformer and women’s rights activist.</p> <p data-aos="fade-up" style={{fontSize:"18px",fontWeight:"500"}}>“Men, their rights, and nothing more; women, their rights, and nothing less.” </p> <p data-aos="fade-up" style={{fontSize:"18px",fontWeight:"500"}}>“There never will be complete equality until women themselves help to make laws and elect lawmakers.”</p></center>
                    
                    </Col>
                    <Col  style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",}} md={6} sm={12}>
                    <center><img style={{width:"100%",height:"100%"}} src={susan}></img></center>
                </Col>
                </Row><br/><br/>
            </div>
            <div style={{paddingTop:"50px"}} className="container">
            <Row>
                <Col  style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",}} md={6} sm={12}>
                    <center><img style={{width:"100%",height:"100%"}} src={grace}></img></center>
                </Col>
                <Col style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",
                paddingTop:"30px"}} md={6} sm={12}>
                    <center><h2 data-aos="fade-up" style={{fontWeight:"bold",borderBottom:"2px solid #efb1ff",paddingBottom:"20px"}}>Grace Hopper</h2></center><br/>
                    <center><p data-aos="fade-up" style={{fontSize:"18px",fontWeight:"500"}}>
                    American computer scientist and United States Navy rear admiral.</p> <p data-aos="fade-up" style={{fontSize:"18px",fontWeight:"500"}}>  “You don't manage people; you manage things. You lead people.”</p></center>
                    
                    </Col>
                </Row>
            </div>
            <div style={{paddingTop:"50px"}} className="container">
                <Row>
                    <Col style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",}} md={6} sm={12}>
                    <center><h2 data-aos="fade-up" style={{fontWeight:"bold",borderBottom:"2px solid #efb1ff",paddingBottom:"20px"}}>Ada Lovelace</h2></center><br/>
                    <center><p data-aos="fade-up" style={{fontSize:"18px",fontWeight:"500"}}> English Mathematician and writer. She is known as the first Computer Programmer.</p> <p data-aos="fade-up" style={{fontSize:"18px",fontWeight:"500"}}>“my ambition should be rather to be great than to be thought so”. </p> </center>
                    
                    </Col>
                    <Col  style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",}} md={6} sm={12}>
                    <center><img style={{width:"100%",height:"100%"}} src={ada1}></img></center>
                </Col>
                </Row><br/><br/>
            </div>
            
            <div style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",
                paddingTop:"50px"}} className="container">
                    <center><h2 data-aos="fade-up" style={{fontWeight:"bold",borderBottom:"2px solid #efb1ff",paddingBottom:"20px"}}>Our Projects</h2></center><br/>
                    <center><p data-aos="fade-up" style={{fontSize:"18px",fontWeight:"500"}}></p></center>
                     <br/><br/>
                     <Carousal/><br/><br/>
                     <br/><br/>
              
                     
                     
                 </div>
                 <Footer/>
            </div>
            
            
        </>
    )
}
export default About;